import * as z from '@/utils/zod/z'

const getSupportedTimezones = () => {
    // This is needed as otherwise by simply importing entities on app-connect (react-native) we get an error
    if (typeof Intl.supportedValuesOf === 'function') {
        return Intl.supportedValuesOf('timeZone').concat(['UTC'])
    }

    return ['UTC']
}

export const validTimezones = getSupportedTimezones()

export const TimezoneSchema = z
    .string()
    .min(1)
    .refine((tz) => validTimezones.includes(tz), {
        message: 'Invalid timezone',
    })
export type Timezone = z.infer<typeof TimezoneSchema>

export const resolveTimezone = (timezone: string, defaultTimezone: Timezone): Timezone =>
    validTimezones.includes(timezone) ? (timezone as Timezone) : defaultTimezone
